import {LOADING} from '../constact'

const loading = data => ({
    type: LOADING,
    data
})
export default loading